'use strict';

// @ts-ignore
var Bigint = BigInt;
function isBigintCase(value) {
  return Number.isInteger(value) && !Number.isSafeInteger(value);
}
function sumNumToBigint() {
  for (var _len = arguments.length, numbers = new Array(_len), _key = 0; _key < _len; _key++) {
    numbers[_key] = arguments[_key];
  }
  return numbers.reduce(function (res, num) {
    return res + Bigint(num);
  }, Bigint(0));
}
function safeToBigint(value) {
  try {
    return Bigint(value);
  } catch (_unused) {
    return value;
  }
}
exports.isBigintCase = isBigintCase;
exports.safeToBigint = safeToBigint;
exports.sumNumToBigint = sumNumToBigint;
